import { Navigate, useParams } from "react-router-dom";

/*
 * Back-compat redirect from `/dashboard/resources/:id` to the new
 * sheet-driven `/dashboard/resources?detail=:id`. Pre-sheet builds shipped
 * deep links to the full-page detail view; this keeps them working without
 * any user-visible regression.
 *
 * The detail page itself has been folded into `<ResourceSheet>` and lives
 * inside `pages/resources/index.tsx`. Once external references age out
 * we can drop this route and component entirely.
 */
export default function SeeResourceRedirect() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/dashboard/resources" replace />;
  return <Navigate to={`/dashboard/resources?detail=${encodeURIComponent(id)}`} replace />;
}
